import { render, staticRenderFns } from "./NewConsultReason.vue?vue&type=template&id=6bf7c0d7"
import script from "./NewConsultReason.vue?vue&type=script&lang=js"
export * from "./NewConsultReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports